import React from "react";
import { Link, useLocation } from "react-router-dom";

function Navbar() {
  const location = useLocation();

  const linkClasses = (path) =>
    `px-4 py-2 rounded-lg transition duration-200 ${
      location.pathname === path
        ? "bg-white text-yellow-600 font-bold"
        : "text-white hover:bg-yellow-100 hover:text-yellow-600"
    }`;

  return (
    <nav className="fixed top-0 left-0 w-full bg-yellow-500 bg-opacity-90 shadow-lg backdrop-blur-md z-50">
      <div className="max-w-6xl mx-auto flex justify-between items-center px-6 py-2">

        {/* LEFT — Site Title */}
        <Link
          to="/main"
          className="text-2xl font-bold text-white flex items-center gap-2"
        >
          ⭐ Millie Mesiner
        </Link>

        {/* RIGHT — Navigation Links */}
        <div className="flex space-x-4">
          <Link to="/main" className={linkClasses("/main")}>
            Home
          </Link>
          <Link to="/main/about" className={linkClasses("/main/about")}>
            About
          </Link>
          <Link to="/main/gallery" className={linkClasses("/main/gallery")}>
            Gallery
          </Link>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
